import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';

bootstrapApplication(App, appConfig)
  // eslint-disable-next-line no-console -- last-resort bootstrap error handler, no logger available
  .catch((err: unknown) => console.error(err));
